import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import { Dispatch, SetStateAction } from "react";

export default function DialogWrapper({
  title,
  content,
  description,
  trigger,
  open,
  setOpen,
  contentClasses,
  isButton,
  stopPropagation,
  hideTitle,
}: {
  title: string | React.ReactNode;
  content: React.ReactNode;
  description?: string;
  trigger: React.ReactNode;
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  contentClasses?: string;
  isButton?: boolean;
  stopPropagation?: boolean;
  hideTitle?: boolean;
}) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger stopPropagation={stopPropagation} child={isButton}>
        {trigger}
      </DialogTrigger>
      <DialogContent
        className={cn(
            "max-h-[85dvh] max-w-[90dvw] min-w-[300px]",
            "md:max-h-[80dvh] md:max-w-[45dvw] md:min-w-[300px]",
            "scrollbar-dialog overflow-y-auto px-4",
            "space-y-0 gap-y-0 wrap-break-word",
          // "min-w-[300px] max-w-[90dvw] md:w-fit md:max-w-[60dvw] max-h-[90dvh] md:max-h-[75dvh]",
          // "overflow-x-auto overflow-y-overlay px-4 scrollbar-transparent",
          // "!font-dank !bg-dialog mx-auto max-w-[95dvw] md:max-w-lg p-3 md:p-4 rounded-sm",
          // "max-w-fit overflow-y-auto",
          contentClasses,
        )}
      >
        <DialogHeader className={cn(hideTitle && "sr-only")}>
          <DialogTitle className={cn("text-left text-2xl", hideTitle && "sr-only")}>
            {title}
          </DialogTitle>
          <DialogDescription
            className={cn("text-left", !description && "hidden")}
          >
            {description}
          </DialogDescription>
        </DialogHeader>
        <div
          className="overflow-x-auto !wrap-break-word pb-8"
          style={{ wordBreak: "break-word" }}
        >
          {content}
        </div>
      </DialogContent>
    </Dialog>
  );
}
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from "@/components/ui/dialog";
// import { Dispatch, SetStateAction } from "react";
//
// export default function DialogWrapper({
//   title,
//   content,
//   description,
//   trigger,
//   open,
//   setOpen,
//   contentClasses,
// }: {
//   title: string;
//   content: React.ReactNode;
//   description?: string;
//   trigger: React.ReactNode;
//   open?: boolean;
//   setOpen?: Dispatch<SetStateAction<boolean>>;
//   contentClasses?: string;
// }) {
//   return (
//     <Dialog open={open} onOpenChange={setOpen}>
//       <DialogTrigger stopPropagation>{trigger}</DialogTrigger>
//       <DialogContent
//         className={`!font-dank !bg-dialog mx-auto max-w-[95dvw] md:max-w-lg p-3 md:p-4 rounded-sm ${contentClasses}`}
//       >
//         <DialogHeader className="!font-ital">
//           <DialogTitle className="text-left">{title}</DialogTitle>
//           <DialogDescription className="text-left">
//             {description}
//           </DialogDescription>
//         </DialogHeader>
//         <div className="">{content}</div>
//       </DialogContent>
//     </Dialog>
//   );
// }
